import React from 'react';
import { Paper, Box, Typography, CardActionArea } from '@mui/material';
import { ArrowForward } from '@mui/icons-material';
import './DashboardCard.css';

interface DashboardCardProps {
  id: string;
  title: string;
  description: string;
  icon: React.ReactNode;
  color: string;
  route: string;
  badge?: number;
  gradient: string;
  darkMode: boolean;
  onClick: (route: string) => void;
}

const DashboardCard: React.FC<DashboardCardProps> = ({
  title, description, icon, color, route, darkMode, onClick,
}) => {
  return (
    <Paper
      className={`dash-card ${darkMode ? 'dark' : 'light'}`}
      elevation={0}
      style={{ '--accent': color } as React.CSSProperties}
    >
      <CardActionArea onClick={() => onClick(route)} className="dash-card-action">
        <Box className="dash-card-body">
          <Box className="dash-icon-wrap" style={{ backgroundColor: `${color}18`, color }}>
            {icon}
          </Box>
          <Box className="dash-text">
            <Typography variant="body2" className="dash-title">{title}</Typography>
            <Typography variant="caption" className="dash-desc">{description}</Typography>
          </Box>
          <ArrowForward className="dash-arrow" />
        </Box>
      </CardActionArea>
    </Paper>
  );
};

export default DashboardCard;
